import * as React from "react";
import { SVGProps } from "react";

// Outline icon: the payment method buttons pass "fill-white" /
// "group-hover:fill-white" for the selected and hover states, so map those to
// the stroke equivalents (stroke-white, group-hover:stroke-white).
const StaticAccount: React.FC<SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.4992 21H24.4997M17.4992 14H24.4997M24.4997 36.75V31.5C24.4997 30.5717 24.1309 29.6815 23.4745 29.0251C22.8181 28.3687 21.9278 28 20.9994 28C20.0711 28 19.1808 28.3687 18.5244 29.0251C17.8679 29.6815 17.4992 30.5717 17.4992 31.5V36.75M10.4986 17.5H6.99833C6.06999 17.5 5.17968 17.8687 4.52325 18.5251C3.86683 19.1815 3.49805 20.0717 3.49805 21V33.25C3.49805 34.1783 3.86683 35.0685 4.52325 35.7249C5.17968 36.3813 6.06999 36.75 6.99833 36.75H35.0006C35.9289 36.75 36.8192 36.3813 37.4756 35.7249C38.1321 35.0685 38.5008 34.1783 38.5008 33.25V15.75C38.5008 14.8217 38.1321 13.9315 37.4756 13.2751C36.8192 12.6187 35.9289 12.25 35.0006 12.25H31.5003M10.4986 36.75V8.75C10.4986 7.82174 10.8674 6.9315 11.5238 6.27513C12.1802 5.61875 13.0706 5.25 13.9989 5.25H28C28.9283 5.25 29.8186 5.61875 30.4751 6.27513C31.1315 6.9315 31.5003 7.82174 31.5003 8.75V36.75"
      stroke="#1A1C1F"
      strokeWidth="3"
      strokeLinecap="round"
      className={className?.replace(/fill-white/g, "stroke-white")}
    />
  </svg>
);

export default StaticAccount;
